// Static, build-time counts derived from src/data/locations.ts.
// Importing this file (instead of the full locations dataset) keeps the
// ~700-line locations module out of the main JS bundle.
// Update these when the underlying dataset changes meaningfully.
export const PROVINSI_COUNT = 38;
export const KOTA_COUNT = 535;
export const KECAMATAN_COUNT = 8044;